module.exports = __webpack_public_path__ + "media/assets/images/blog/POST-18MARZO-25-small-c10cafb6f35b2914bc18c1ca5894f585.png";